module.exports = __webpack_public_path__ + "static/media/implants.92aa2eed.svg";